<template>
  <section class="uk-padding uk-padding-remove-horizontal">
    <div class="uk-container uk-container-large uk-margin-top uk-margin-bottom">
      <div class="uk-margin-left uk-flex uk-flex-between">
        <h2 class="uk-h3 uk-text-bold">
          Featured in
          <sup class="uk-text-small vb-font-family-global uk-text-muted uk-text-normal">({{ count }})</sup>
        </h2>
        <a class="uk-text-small" :href="route">
          <span class="uk-text-bold" style="border-bottom: 1px solid">View all</span>
        </a>
      </div>
      <div class="uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-3@l uk-child-width-1-4@xl" data-uk-grid>
        <div v-for="school in schools" :key="school.id">
          <article data-uk-grid>
            <div class="uk-width-1-5 uk-width-1-3@s">
              <a
                class="uk-background-secondary uk-border-rounded uk-display-block vb-hover-scale"
                style="border: 1px solid #3d3d3d; padding: 8px"
                :href="`/${school['slug']}`"
              >
                <img
                  class="uk-display-block vb-hover-scale__inner"
                  style="border-radius: 4px"
                  :data-src="school['image'] || getImgPath('/img/brand/placeholder-light.svg')"
                  data-uk-img
                  :alt="`${school['name']} mascot`"
                />
              </a>
            </div>
            <div class="uk-width-4-5 uk-width-2-3@s">
              <h3 class="uk-h5 uk-text-bold uk-margin-small-bottom">
                <a :href="`/${school['slug']}`">{{ school['name'] }}</a>
              </h3>
              <p class="uk-text-small uk-margin-remove">
                {{ school['address'] }}, {{ school['city_name'] }},
                {{ school['state_name'] }}
              </p>
            </div>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getImgPath } from '@/shared/js/helpers'

export default {
  name: 'SchoolsCollection',
  props: {
    schools: {
      type: Array,
      default: () => [],
    },
    count: {
      type: Number,
      default: 0,
    },
    route: {
      type: String,
      default: '/',
    },
  },
  methods: { getImgPath },
}
</script>
